module.exports = __webpack_public_path__ + "static/media/logo-flower.b95c89e5.png";